// ABOUTME: Help-icon explainer for the Dekking column on the Inkoopadvies "Al ingekocht" card.
// ABOUTME: One box per coverage state, colour-matched to the label shown on the row.

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExplainerModal from "../../../../theme/Modal/ExplainerModal/ExplainerModal";
import ExplainerBox from "../../../../theme/Modal/ExplainerModal/ExplainerBox";

const EMAdviceCoverage = () => {
    const { t } = useTranslation();

    return (
        <ExplainerModal>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <ExplainerBox
                    variant="orange"
                    title={t("partly_covered")}
                    text={"advice_coverage_partly_explainer"}
                />
            </Box>
        </ExplainerModal>
    );
}

export default EMAdviceCoverage;
